import api from '../client';

export const ChatService = {
  getRooms: () => api.get('/chat/rooms'),
  createRoom: (data) => api.post('/chat/rooms', data),
  getMessages: (roomId) => api.get(`/chat/rooms/${roomId}/messages`),
  sendMessage: (roomId, data) => api.post(`/chat/rooms/${roomId}/messages`, data),
  readRoom: (roomId) => api.post(`/chat/rooms/${roomId}/read`),
  deleteRoom: (roomId, deleteForAll = false) => api.delete(`/chat/rooms/${roomId}${deleteForAll ? '?delete_for_all=true' : ''}`),
  updateMessageColor: (messageId, color) => api.patch(`/chat/messages/${messageId}/color`, { color }),
  togglePinRoom: (roomId) => api.post(`/chat/rooms/${roomId}/pin`),
  initSystemChats: () => api.get('/chat/system/init'),
};
